module.exports = __webpack_public_path__ + "c1195863a49bcfbba422276e34ea650e.jpg";